export default {
    disagreeButton: {
        backgroundColor: "#E53935",
        color: "#FFF"
    },

    agreeButton: {
        backgroundColor: "#43A047",
        color: "#FFF"
    },

    containerCameraOff: {
        alignItems: "center",
        backgroundColor: "#424242",
        display: "flex",
        justifyContent: "center",
        paddingTop: "100%",
        position: "relative",
        width: "100%"
    },

    textcameraOff: {
        alignItems: "center",
        bottom: 0,
        color: "#FAFAFA",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        left: 0,
        position: "absolute",
        right: 0,
        top: 0,
        width: "100%"
    },

    cameraButton: {
        margin: 8
    },

    validationButton: {
        backgroundColor: "#43A047",
        color: "#FFF"
    },

    cancelButton: {
        backgroundColor: "#E53935",
        color: "#FFF",
        fontWeight: "thin"
    },

    damagedIcon: {
        backgroundColor: "#E53935"
    },

    undamagedIcon: {
        backgroundColor: "#43A047"
    }
};



// WEBPACK FOOTER //
// ./src/app/styles/QrCodeReader.ts